<div class="cont">
  <span>{{errCode}}</span>
  <p>{{message}}</p>

  <div class="button-cont">
    <awc-button
      [text]="'Download Log'"
      [suffixIcon]="!downloadingLog ? { icon: Icons.DOWNLOAD } : { icon: Icons.SPINNER }"
      [disabled]="downloadingLog"
      (buttonClicked)="onDownloadLog()"
    ></awc-button>
    <awc-button
      [text]="'Download Input'"
      [suffixIcon]="!downloadingInput ? { icon: Icons.DOWNLOAD } : { icon: Icons.SPINNER }"
      [disabled]="downloadingInput"
      (buttonClicked)="onDownloadInput()"
    ></awc-button>
  </div>

</div>
